import { render, staticRenderFns } from "./clueMaterial.vue?vue&type=template&id=6d42bf8a&scoped=true&"
import script from "./clueMaterial.vue?vue&type=script&lang=js&"
export * from "./clueMaterial.vue?vue&type=script&lang=js&"
import style0 from "./clueMaterial.vue?vue&type=style&index=0&id=6d42bf8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d42bf8a",
  null
  
)

export default component.exports